module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-78.2c6f172e.svg";